/* @flow */

import type { Node } from 'react';
import React, { useState } from 'react';

import loadable from '@loadable/component';
import { useDispatch } from 'react-redux';
import Breadcrumbs from '../../components/Breadcrumbs';

import { ArticleBody, ArticleText, Root, Title, Wrapper } from '../article/styles';
import { Container } from '../../components/Layout/styles';
import Button from '../../components/Button2.0';
import { PopupContentWrapper } from '../../components/Header/styles';
import { CLEAR_ACTION_CALLBACK_POPUP } from '../../constants/popup';
import type { TDispatch } from '../../types/core';

const Modal = loadable(() => import('../../components/Modal/Modal'), { fallback: null, ssr: false });
const CallbackPopup = loadable(() => import('../../components/CallbackModalForm'), {
	fallback: null,
	ssr: false,
});

const getBreadcrumbs = (article) => [
	{
		index: 1,
		title: 'Главная',
		link: '/',
	},
	{
		index: 2,
		title: article.title,
		link: article.slug,
	},
];

type Props = {
	article: {
		createdAt: string,
		description: string,
		id: number,
		slug: string,
		title: string,
	},
	route: string,
};

const Static = ({ article, route }: Props): Node => {
	const dispatch: TDispatch = useDispatch();
	const [showCallback, setShowCallback] = useState(false);

	const closeCallback = () => {
		setShowCallback(false);
		dispatch({ type: CLEAR_ACTION_CALLBACK_POPUP });
	};

	return (
		<Root>
			<Container>
				<Breadcrumbs data={getBreadcrumbs(article)} />

				<ArticleBody>
					<header>
						<Title>{article.title}</Title>
					</header>

					<Wrapper>
						<ArticleText
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{ __html: article.description }}
						/>
					</Wrapper>
					{route === 'soglasie-na-obrabotku-personalnyh-dannyh' && (
						<div style={{ margin: '40px auto' }}>
							<Button color="secondary" size="xs" design="rounded" onClick={() => setShowCallback(true)}>
								Отозвать согласие
							</Button>
							<Modal isShowing={showCallback} hide={closeCallback}>
								<PopupContentWrapper>
									<CallbackPopup callbackType="callback" />
								</PopupContentWrapper>
							</Modal>
						</div>
					)}
				</ArticleBody>
			</Container>
		</Root>
	);
};

export default Static;
